import React from 'react';
import { useSelector } from 'react-redux';
import { selectServiceRequestFormStep } from '../../store/selectors/serviceRequestForm';
import ServiceRequestFormAsset from './ServiceRequestFormAsset';
import ServiceRequestFormCategory from './ServiceRequestFormCategory';
import ServiceRequestFormDetails from './ServiceRequestFormDetails';
import ServiceRequestFormFaqs from './ServiceRequestFormFaqs';
import ServiceRequestFormIssueType from './ServiceRequestFormIssueType';
import ServiceRequestFormQuestion from './ServiceRequestFormQuestion';
import ServiceRequestFormReview from './ServiceRequestFormReview';
import ServiceRequestFormSuite from './ServiceRequestFormSuite';

export interface ServiceRequestFormStepsProps {
  [key: string]: any;
}

const ServiceRequestFormSteps = (props: ServiceRequestFormStepsProps) => {
  const serviceRequestFormStep: any = useSelector(selectServiceRequestFormStep);

  switch (serviceRequestFormStep) {
    case 0:
      return <ServiceRequestFormSuite {...props} />;
    case 1:
      return <ServiceRequestFormAsset {...props} />;
    case 2:
      return <ServiceRequestFormIssueType {...props} />;
    case 3:
      return <ServiceRequestFormCategory {...props} />;
    case 4:
      return <ServiceRequestFormFaqs {...props} />;
    case 5:
      return <ServiceRequestFormQuestion {...props} />;
    case 6:
      return <ServiceRequestFormDetails {...props} />;
    case 7:
      return <ServiceRequestFormReview />;
    default:
      return null;
  }
};

export default ServiceRequestFormSteps;
